module.exports = __webpack_public_path__ + "static/img/iStock-920496608_mod.3e1c2bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iStock-920496608_mod.png
// module id = 1719
// module chunks = 5